import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../../design-system/components/form/button/Button';
import { IconInstagram } from '../../../../../../design-system/components/icons/Instagram';
import { BrandHandMarkCircleVariant2 } from '../../../../../../design-system/components/illustration/BrandHandMarkCircleVariant2';
import { Typography } from '../../../../../../design-system/components/typography/Typography';
import { useCurrentSite } from '../../../../../../shared/providers/currentSite/useCurrentSite';

import styles from './EvaneosSocialMediaCard.module.css';

export function EvaneosSocialMediaCard() {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const {
        currentSite: { socialNetworks },
    } = useCurrentSite();

    const instagramUrl = socialNetworks.instagram.url;

    return (
        <div className={styles.card}>
            <BrandHandMarkCircleVariant2 className={styles.illustration} />

            <Typography scale="secondary-s-bold" className={styles.title}>
                {formatMessage({ id: 'page.home.evaneos.instagram.card.title' })}
            </Typography>

            <Button
                priority="secondary"
                iconPosition="left"
                Icon={IconInstagram}
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                    trackEvent((ampli, defaultProperties) => {
                        ampli.instagramClicked({
                            ...defaultProperties,
                            block: 'social',
                            url_redirection: instagramUrl,
                        });
                    });
                }}
            >
                Evaneos
            </Button>
        </div>
    );
}
